// extracted by mini-css-extract-plugin
export default {"container":"Onboarding_container__a51WL","footer":"Onboarding_footer__nXPvT"};